import { CustomAttributeGroupSimple } from "../CustomAttributeGroupSimple/CustomAttributeGroupSimple";

import { Fragment, type JSX } from "react";

import {
  AttributeGroupAccordion,
  AttributeGroupContent,
  AttributeGroupProps,
  AttributeGroupVariant,
} from "@plansoft-configuration-renderer/components";

export function CustomAttributeGroup(props: AttributeGroupProps): JSX.Element {
  const { variant = AttributeGroupVariant.Accordion } = props;

  switch (variant) {
    case AttributeGroupVariant.Accordion:
      return <AttributeGroupAccordion {...props} />;
    case AttributeGroupVariant.Simple:
      return <CustomAttributeGroupSimple {...props} />;
    case AttributeGroupVariant.Content:
      return <AttributeGroupContent {...props} />;
    default:
      return <Fragment />;
  }
}
